export const familyDetailsHeaders = [
  'First Name',
  'Middle Name',
  'Last Name',
  'Date of Birth',
  'Passport No.',
  'Relationship',
];
